import { ObjectId } from '@racemap/sdk/schema/base';
import { capitalize } from '@racemap/utilities/functions/utils';
import type { Location } from 'react-router';
import shortHash from 'shorthash2';

export function sendAnalyticsEvent(
  eventName: Gtag.EventNames | string,
  eventParams?: Gtag.EventParams | Gtag.ControlParams | Gtag.CustomParams,
) {
  if (window.gtag === undefined) return;
  if (eventParams) {
    console.debug('GA event:', eventName, '---', eventParams);
  } else {
    console.debug('GA event:', eventName);
  }
  gtag('event', eventName, eventParams);
}

const getAggregatedTitle = (pathname: string) => {
  const parts = pathname.split('/').filter((part) => part.length > 0);
  return `Racemap | Admin | ${parts
    .filter((p) => p !== 'admin')
    .map((p) => (ObjectId.isValid(p) ? '#' : capitalize(p)))
    .join(' | ')}`;
};

export function sendPageViewEvent(location: Location) {
  if (window.gtag === undefined) return;

  const pathname = location.pathname;
  const titleFull = `Racemap | Admin | ${location.pathname.replace('/admin/', '').replace(/\//g, ' | ')}`;
  const titleAggregated = getAggregatedTitle(pathname);
  console.log('Page view event:', location.pathname, '---', titleAggregated);

  gtag('event', 'page_view', {
    page_path: pathname,
    page_title: titleAggregated,
    page_title_full: titleFull,
  });
}

export function sendErrorEvent(error: unknown, fatal = false) {
  if (window.gtag === undefined) return;

  const errorName = error instanceof Error ? error.name : 'UnknownError';
  const errorMessage = error instanceof Error ? error.message : 'UnknownError';
  const errorHash = shortHash(errorMessage);

  gtag('event', 'exception', {
    description: `${errorName} - ${errorHash}`,
    fatal,
  });
}
